import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { COLORS } from "../config/theme/baseTheme";
import {
    chipFilterStyles,
  excelDownloadStyles,
  useDialogPaperPropsRootStyle,
  usePublishRouteDialogStyle,
  rootSectionWithContainer,
  tagStyles,
  orderTag,
} from "SharedComponent/styles/sharedStyles";
import { useColorStyles } from "SharedComponent/styles/Colores.styles";

export const useStyles = makeStyles((theme: Theme) => {
  const {
    publishDialogPaperPropsRoot,
    deleteDialogPaperPropsRoot,
    hubSelectionDialogPaperPropsRoot,
    publishDialogContentContainer
  } = useDialogPaperPropsRootStyle(theme);

  const {
    hubSelectionDialogTitle,
    hubSelectionDialogContentContainer,
    publishDialogButtonsContainer,
    deleteDialogButtonsContainer,
    hubSelectionDialogButtonsContainer,
    deleteDialogContentContainer,
    publishErrorPopupContainer,
  } = usePublishRouteDialogStyle(theme);

    const {
      excelDownloadStatus,
      excelDownloadStatusText,
      checkedIconStyle,
      close,
      closeIcon,
      excelDownloadError,
      button,
      colSettings,
      buttonContainer,
    } = excelDownloadStyles(theme);

  return createStyles({
    ...rootSectionWithContainer(theme),
    tabPanelContainer: {
      flexDirection: "column",
      height: "100%",
      "& .panelItem": {
        width: "100%",
        "&.chipFilter": {
          padding: "16px 16px 16px 0px",
          "& .chipsContainer": {
            display: "flex",
            justifyContent: "space-between",
            "& .chipFilterItem": {
               '&.pickUpBucket': {
                 minWidth: "14%",
               },
              height: 36,
              minWidth: "16%",
              ...chipFilterStyles(theme),
            },
          },
        },
        "&.gridWrapper": {
          height: "calc(100% - 98px)",
          "& .idLink": {
            cursor: "pointer",
            color: theme.palette.primary.main,
            fontWeight: 600,
            fontSize: 12,
            paddingRight: 1,
            '&.disabled': {
              cursor: 'default',
              pointerEvents: 'none',
              color: COLORS.GREY_SCALE,
            },
          },
          "& .delayedLink": {
            color: COLORS.DARK_RED,
            '&.disabled': {
              color: COLORS.GREY_SCALE,
            },
          },
          "& .actionsLink": {
            cursor: "pointer",
            color: theme.palette.primary.main,
            fontWeight: 600,
            fontSize: 14,
            '&.disabled': {
              cursor: 'default',
              pointerEvents: 'none',
              color: COLORS.GREY_SCALE,
            },
          },
        },
      },
    },
    infoSection: {
      display: "flex",
      alignItems: "center",
    },
    infoIconStyle: {
      height: "12px",
      width: "12px",
      marginLeft: "6px",
    },
    publishDialogContentContainer,
    publishDialogPaperPropsRoot,
    deleteDialogPaperPropsRoot,
    hubSelectionDialogPaperPropsRoot,
    hubSelectionDialogTitle,
    hubSelectionDialogContentContainer,
    publishDialogButtonsContainer,
    deleteDialogButtonsContainer,
    hubSelectionDialogButtonsContainer,
    deleteDialogContentContainer,
    publishErrorPopupContainer,
    actionsHeader: {
      alignItems: "center",
      "& .actionItem": {
        cursor: "pointer",
        "& .icon": {
          padding: theme.spacing(0.25),
          "&.editIcon": {
            marginRight: theme.spacing(0.75),
          },
        },
      },
    },
    deliveryAreaHeader: {
      alignItems: "center",
      "& .columnValue": {
        fontSize: 12,
      },
    },
    statusHeaderContainer: {
      "& .tag": {
        ...tagStyles(theme).base,
       ...useColorStyles(theme),
      },
      "& .orderTag": {
        ...orderTag(theme),
        '&.GOLDEN_BELL': {
          color: COLORS.GOLDEN_BELL,
          borderColor: COLORS.GOLDEN_BELL
      },
      '&.MINSK': {
          color: COLORS.SCAMPI,
          borderColor: COLORS.SCAMPI
      },
      '&.READY_BLUE': {
          color: COLORS.READY_BLUE,
          borderColor: COLORS.READY_BLUE
      },
      '&.SCAMPI': {
          color: COLORS.SCAMPI,
          borderColor: COLORS.SCAMPI
      },
      '&.INFO_BLUE': {
          color: COLORS.INFO_BLUE,
          borderColor: COLORS.INFO_BLUE
      },
      '&.MINSK_DARK': {
          color: COLORS.MINSK_DARK,
          borderColor: COLORS.MINSK_DARK
      },
      '&.DRIFT_WOOD': {
          color: COLORS.DRIFT_WOOD,
          borderColor: COLORS.DRIFT_WOOD
      },
      '&.TAG_YEllOW': {
          color: COLORS.TAG_YEllOW,
          borderColor: COLORS.TAG_YEllOW
      },
      '&.PERSIAN_GREEN_DARK': {
          color: COLORS.PERSIAN_GREEN_DARK,
          borderColor: COLORS.PERSIAN_GREEN_DARK
      },
      '&.PARTIAL_SUCCESS_GREEN': {
          color: COLORS.PARTIAL_SUCCESS_GREEN,
          borderColor: COLORS.PARTIAL_SUCCESS_GREEN
      },
      '&.SILVER_CHALICE2': {
          color: COLORS.SILVER_CHALICE2,
          borderColor: COLORS.SILVER_CHALICE2
      },
      '&.PALE_RED': {
          color: COLORS.PALE_RED,
          borderColor: COLORS.PALE_RED
      },
      '&.GREEN_BLUE': {
          color: COLORS.GREEN_BLUE,
          borderColor: COLORS.GREEN_BLUE
      },
      '&.MAROON': {
          color: COLORS.MAROON,
          borderColor: COLORS.MAROON,
        },
      '&.EMRALD': {
           color: COLORS.EMRALD,
           borderColor: COLORS.EMRALD
        },
      },
    },
    customFilter: {
      display: "flex",
       alignItems: "center",
       padding: "4px 12px",
       borderRadius: "38px",
       backgroundColor: "#F7F8F9", // Static gray background for the badge
       fontWeight: "bold",
       textAlign: "center",
       border: '1px solid #EBF0F5'
    },
    excelDownloadStatus,
    excelDownloadStatusText,
    checkedIconStyle,
    close,
    closeIcon,
    excelDownloadError,
    button,
    colSettings,
    buttonContainer,
    supportDriverHeader: {
      alignItems: "center",
      "& .columnValue": {
        fontSize: 12,
      },
    },
    deselectAll: {
      marginLeft: "10px",
      backgroundColor: COLORS.MINE_SHAFT_LIGHT,
      color: COLORS.PRIMARY_MAIN,
      borderRadius: "20px",
      padding: "6px 16px",
      textTransform: "none" as const,
      fontSize: "14px",
      fontWeight: 700,
    }, 
    courierActionContainer: {
      marginLeft: "10px",
      height: "48px",
    },
    rowSwitchingProgress: {
      backgroundColor: `${COLORS.SECONDARY_MAIN} !important`,
      opacity: 0.7,
      cursor: 'not-allowed !important',
      position: 'relative',
      '& .MuiTableCell-root': {
        pointerEvents: 'none',
        position: 'relative',
      },
      '& .MuiCheckbox-root': {
        visibility: 'hidden !important',
      },
      '&:hover': {
        backgroundColor: `${COLORS.SECONDARY_MAIN} !important`,
        opacity: 0.7,
      },
    },
  });
});
